export default __webpack_public_path__ + "slices/main/assets/public/media/logos/bloomberg.720e38f5cf3011680604d4a4f81c28a7.png";